import {Component, Input} from '@angular/core';
import {NgIf} from '@angular/common';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {v4 as uuidv4} from 'uuid';

@Component({
    selector: 'app-input-line-form',
    templateUrl: './input-line-form.component.html',
    styleUrls: ['./input-line-form.component.scss'],
    imports: [NgIf, ReactiveFormsModule, TranslateModule]
})
export class InputLineFormComponent {
    @Input() name = uuidv4();
    @Input() id = uuidv4();
    @Input() labelName = '';
    @Input() placeholder?: any;
    @Input() submitted = false;
    @Input() readonly = false;
    @Input() group = new FormGroup({});
    @Input() control?: FormControl | undefined;
    @Input() controlName = '';
    @Input() type?: string;
    @Input() tabindex?: number;
    @Input() autocomplete?: string;
    @Input() invalid?: boolean;
    /** Off by default: these fields hold names, IBANs, addresses and codes, where the dictionary only adds noise. */
    @Input() spellcheck = false;

    get lineControl(): FormControl {
        return this.control !== undefined ? this.control : this.group.get(this.controlName) as FormControl
    }

    get isRequired(): boolean {
        return this.lineControl.hasValidator(Validators.required)
    }

    get isInvalid(): boolean {
        return this.submitted && (!!this.lineControl.errors || !!this.invalid);
    }
}
